// Lightweight logger — emits warn/error/info only in development.
// Kept intentionally silent in production to avoid leaking internals in
// browser consoles. Errors that must always surface should use toast()
// from the UI, not this logger.
const isDev =
  typeof process !== 'undefined' &&
  process.env &&
  process.env.NODE_ENV !== 'production';

const noop = () => {};

export const logger = {
  info: isDev ? (...args) => console.info('[pg]', ...args) : noop,
  warn: isDev ? (...args) => console.warn('[pg]', ...args) : noop,
  error: isDev ? (...args) => console.error('[pg]', ...args) : noop,
};

export default logger;
